import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "move-all-confirm__title" }
const _hoisted_2 = { class: "move-all-confirm__description" }
const _hoisted_3 = { class: "move-all-confirm__actions" }

import { ref } from "vue"
import AppButton from "@/components/ui-kit/button/AppButton.vue"
import { useConfirmKeys } from "@/composables/useConfirmKeys"


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationMoveAllConfirm',
  emits: ["cancel", "confirm"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$root",
    ref: $root,
    class: "move-all-confirm"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('notifications_move_all_title')), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('notifications_move_all_question')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppButton, {
        class: "move-all-confirm__actions-button",
        type: "secondary",
        label: _ctx.$t('cancel_short'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, null, 8, ["label"]),
      _createVNode(AppButton, {
        class: "move-all-confirm__actions-button",
        label: _ctx.$t('confirm_short'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, null, 8, ["label"])
    ])
  ], 512))
}
}

})